document.addEventListener('click', function (e) {
  var hotspot = e.target.closest('.shoppable-image__hotspot');
  document.querySelectorAll('.shoppable-image__hotspot.is-active').forEach(function (el) {
    if (el !== hotspot) el.classList.remove('is-active');
  });
  if (hotspot) {
    hotspot.classList.toggle('is-active');
    e.preventDefault();
  } else if (!e.target.closest('.shoppable-image__card')) {
    document.querySelectorAll('.shoppable-image__hotspot.is-active').forEach(function (el) {
      el.classList.remove('is-active');
    });
  }
});
